export const BP_CONTAINER_PAD_X = [16, 59, null, null, 107];
export const BP_CONTAINER_PAD_Y = [16, 40, null, null, 50];
export const BP_MAX_WIDTH = '1152px';

export const FORM_INPUT_PADDING = '8px';
